import type {
  AvatarConfig,
  AvatarHairColor,
  AvatarOutfitColor,
  AvatarSkinTone,
} from '@etown/shared';
import { AVATAR_OUTFIT_COLORS } from '@etown/shared';

/**
 * Zuordnung der Avatar-Part-IDs zu konkreten Farben — bewusst nur hier im
 * Client (Theme-Hoheit, wie bei Tile-IDs). Server und Persistenz kennen
 * ausschliesslich die IDs.
 */

export const SKIN_HEX: Record<AvatarSkinTone, number> = {
  hell: 0xf6d7bd,
  beige: 0xeab98d,
  oliv: 0xc98e5f,
  braun: 0x9c6b43,
  dunkel: 0x6b4a30,
};

export const HAIR_HEX: Record<AvatarHairColor, number> = {
  schwarz: 0x2b2622,
  braun: 0x6b4a30,
  blond: 0xe8c56b,
  rot: 0xc4562e,
  grau: 0xb8bcc4,
  blau: 0x5aa9e6,
};

/** Outfit-Farben = dieselbe Familie wie AVATAR_COLORS (ein Produkt-Look). */
export const OUTFIT_HEX: Record<AvatarOutfitColor, number> = {
  koralle: 0xff6b5e,
  teal: 0x2ec4b6,
  lavendel: 0x9b8cff,
  honig: 0xf2b33d,
  gruen: 0x3bb273,
  himmel: 0x5aa9e6,
  pink: 0xe673b8,
  graublau: 0x8a96a8,
};

/**
 * Liefert die Avatar-Konfiguration eines Spielers oder einen deterministischen
 * Fallback aus dem avatarColor-Index (Benutzer ohne gespeicherte Konfiguration
 * sehen aus wie bisher: einfarbige Figur in ihrer Zufallsfarbe).
 */
export function resolveAvatar(avatar: AvatarConfig | null, avatarColor: number): AvatarConfig {
  if (avatar) return avatar;
  const outfit = AVATAR_OUTFIT_COLORS[avatarColor % AVATAR_OUTFIT_COLORS.length] ?? 'teal';
  return {
    skin: 'beige',
    hair: 'kurz',
    hairColor: 'braun',
    shirtColor: outfit,
    pantsColor: 'graublau',
    accessory: 'keins',
  };
}
